<template>
  <div class="wrap">
      <div class="containter">
          <site-type-menu ref="siteTypeMenu" @onChangeMenu="onChangeMenu"></site-type-menu>
          <div class="content" v-loading="loading">
              <div class="c-header">
                  <div class="header-group-left">
                      <el-button type="primary" size="mini" @click="addSite">添加微站</el-button>
                  </div>
              </div>

              <div class="c-main">
                  <div class="microsite-grid">
                      <div class="microsite-card" v-for="site in siteTypeList" :key="site._id">
                          <div class="microsite-cover" 
                               :class="{ 'cover-error': site.coverError }"
                               :style="{ backgroundImage: site.coverError ? 'none' : `url(${site.cover || defaultCover})` }"
                               @load="handleCoverLoad(site)"
                               @error="handleCoverError(site)">
                              <div v-if="site.coverError" class="cover-error-text">封面加载失败</div>
                              <div class="microsite-hover-actions">
                                  <div class="qrcode-container">
                                      <qrcode :value="getSiteUrl(site._id)" :options="{ width: 120 }"></qrcode>
                                      <div class="qrcode-title">微站二维码</div>
                                  </div>
                                  <div class="hover-actions-buttons">
                                      <el-button size="mini" type="primary" @click.stop="copySiteUrl(site._id)">复制链接</el-button>
                                      <el-button size="mini" type="success" @click.stop="previewSite(site._id)">预览</el-button>
                                  </div>
                              </div>
                          </div>
                          <div class="microsite-info">
                              <div class="microsite-header">
                                  <h3 class="microsite-title">{{ site.name }}</h3>
                                  <el-tag v-if="site.isHome" size="mini" type="success">首页</el-tag>
                              </div>
                              <div class="microsite-stats">
                                  <!-- <div class="stat-item">
                                      <i class="el-icon-view"></i>
                                      <span>{{ site.viewCount || 0 }}</span>
                                  </div> -->
                                  <!-- <div class="stat-item">
                                      <i class="el-icon-date"></i>
                                      <span>{{ formatDate(site.updatedAt || site.createdAt) }}</span>
                                  </div> -->
                              </div>
                              <div class="microsite-actions">
                                  <el-button type="primary" size="mini" @click="editSite(site)">编辑微站</el-button>
                                  <el-dropdown size="mini" trigger="click" @command="(cmd) => handleCommand(cmd, site)">
                                      <el-button size="mini" type="text">
                                          <i class="el-icon-more"></i>
                                      </el-button>
                                      <el-dropdown-menu slot="dropdown">
                                          <el-dropdown-item command="manage">页面管理</el-dropdown-item>
                                          <el-dropdown-item command="setting">基础设置</el-dropdown-item>
                                          <el-dropdown-item command="ticket">门票管理</el-dropdown-item>
                                          <el-dropdown-item command="changeCover">更改封面</el-dropdown-item>
                                          <el-dropdown-item command="rename">重命名</el-dropdown-item>
                                          <el-dropdown-item command="delete" v-if="site._id !== '67834fc361100336e0ce0086'">删除</el-dropdown-item>
                                      </el-dropdown-menu>
                                  </el-dropdown>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <!-- 微站编辑对话框-->
      <el-dialog width="30%" :title="dialogTitle" :visible.sync="dialogVisible">
          <el-form :model="currentSite" ref="siteForm" label-width="100px">
              <el-form-item label="微站名称" prop="name" :rules="[{ required: true, message: '请输入微站名', trigger: 'blur' }]">
                  <el-input v-model="currentSite.name" placeholder="请输入微站名"></el-input>
              </el-form-item>
              <el-form-item label="分类" prop="category">
                  <el-select v-model="currentSite.category" placeholder="请选择分类" @change="handleCategoryChange">
                      <el-option v-for="item in categoryOptions" :key="item._id" :label="item.name" :value="item._id">
                      </el-option>
                  </el-select>
              </el-form-item>
              
              <el-form-item label="子分类" prop="subCategory">
                  <el-select v-model="currentSite.subCategory" placeholder="请选择子分类" :disabled="!currentSite.category || !subCategoryOptions.length" clearable>
                      <el-option v-for="item in subCategoryOptions" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="描述" prop="description">
                  <el-input type="textarea" v-model="currentSite.description" placeholder="请输入微站描述"></el-input>
              </el-form-item>
              <el-form-item label="封面" prop="cover">
                  <div class="cover-container">
                      <el-upload
                          class="cover-uploader"
                          action="/api/upload"
                          :show-file-list="false"
                          :on-success="handleCoverSuccess"
                          :before-upload="beforeCoverUpload">
                          <div class="image-wrapper">
                              <img v-if="currentSite.cover" :src="currentSite.cover" class="cover-image">
                              <i v-else class="el-icon-plus cover-uploader-icon"></i>
                          </div>
                      </el-upload>
                      <div class="cover-tips">
                          <i class="el-icon-info"></i>
                          建议尺寸：800×400px，支持 JPG、PNG 格式，大小不超过 2MB
                      </div>
                  </div>
              </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取消</el-button>
              <el-button type="primary" @click="saveSite('siteForm')">保存</el-button>
          </span>
      </el-dialog>

      <!-- 分享编辑 -->
      <el-dialog width="1200px" :title="dialogTitleShare" :visible.sync="dialogVisibleShare">
          <el-form :model="shareData" ref="ruleForm" label-width="120px">
              <div class="article-form">
                  <div class="article-form-left">
                      <el-form-item label="分享图标" prop="cover">
                          <FaImageUpload v-model="shareData.icon" :maxCount="1" />
                      </el-form-item>
                      <el-form-item label="分享标题" prop="title">
                          <el-input v-model="shareData.title" size="small"></el-input>
                      </el-form-item>
                      <el-form-item label="分享描述" prop="description">
                          <el-input 
                            v-model="shareData.description" 
                            type="textarea" 
                            :rows="3"
                            placeholder="请输入分享描述（支持多行输入）"
                            resize="both"
                            size="small"
                          ></el-input>
                      </el-form-item>
                      <el-form-item label="关联表单" prop="formId">
                          <el-select 
                              v-model="shareData.formId" 
                              placeholder="请选择关联表单" 
                              style="width: 100%;" 
                              clearable
                              :loading="formLoading"
                          >
                              <el-option
                                  v-for="item in formOptions"
                                  :key="item.form_id || item.id"
                                  :label="item.title"
                                  :value="item.form_id">
                              </el-option>
                              <template slot="empty">
                                  <div style="text-align: center; padding: 10px;">
                                      <i class="el-icon-document" style="font-size: 18px; color: #dcdfe6;"></i>
                                      <p style="margin: 5px 0 0; color: #909399;">暂无可用表单</p>
                                  </div>
                              </template>
                          </el-select>
                          <div class="form-tip" style="margin-top: 5px; font-size: 12px; color: #909399;">
                              <template v-if="shareData.formId">
                                  已关联表单，用户可以通过表单提交信息
                              </template>
                              <template v-else>
                                  <el-alert
                                      title="未关联表单，用户将无法报名或提交信息"
                                      type="warning"
                                      :closable="false"
                                      show-icon
                                      style="margin-top: 5px;">
                                  </el-alert>
                              </template>
                          </div>
                      </el-form-item>
                      <el-form-item label="是否开启" prop="title">
                        <el-switch v-model="shareData.site_switch" active-value="1" inactive-value="0" />
                      </el-form-item>
                  </div>
              </div>
          </el-form>
          <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleShare = false">取消</el-button>
              <el-button type="primary" @click="saveShare()">保存</el-button>
          </span>
      </el-dialog>

      <!-- 其他对话框保持不变-->
      <el-dialog v-if="formDialogVisible" fullscreen :title="formDialogtitle" :visible.sync="formDialogVisible">
          <iframe allow='clipboard-read; clipboard-write' class="form-iframe" :src="formDialogUrl"
              frameborder="0"></iframe>
      </el-dialog>

      <!-- 门票管理 -->
      <el-dialog width="1200px" :title="dialogTitleTicket" :visible.sync="dialogVisibleTicket">
        <!-- 添加门票总开关-->
        <div style="margin-bottom: 20px; display: flex; align-items: center; justify-content: space-between;">
          <div style="display: flex; align-items: center;">
            <span style="margin-right: 10px; font-weight: bold;">门票功能总开关</span>
            <el-switch
              v-model="siteTicketEnabled"
              @change="handleSiteTicketStatusChange"
              active-text="开"
              inactive-text="关闭">
            </el-switch>
          </div>
          <el-button type="primary" @click="editTicket()">添加门票</el-button>
        </div>

        <el-table :data="ticketListData" style="width: 100%">
          <el-table-column label="门票名称" prop="ticketName" />
          <el-table-column label="价格" prop="ticketPrice" />
          <el-table-column label="已售/总数" prop="sold" />
          <el-table-column label="销售状态" prop="saleStatus">
            <template slot-scope="scope">
              <el-tag 
                :type="scope.row.saleStatus == 1 ? 'success' : scope.row.saleStatus == 0 ? 'warning' : 'danger'"
              >
                {{ scope.row.saleStatus == 1 ? '售票' : scope.row.saleStatus == 0 ? '未开' : '已结束' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="开始售票时间" width="180px" prop="startTime" />
          <el-table-column label="结束售票时间" width="180px" prop="endTime" />
          <el-table-column label="启用状态" prop="status">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" @change="handleStatusChange(scope.row)" />
            </template>
          </el-table-column>

          <el-table-column label="操作" width="280px">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleCommand('editTicket', scope.row)">编辑</el-button>
              <el-button size="mini" type="primary" @click="openForm">表单管理</el-button>
              <el-button size="mini" type="danger" @click="handleCommand('delTicket', scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <!-- 门票编辑 -->
      <el-dialog width="1200px" :title="dialogTitleTicketDetails" :visible.sync="dialogVisibleTicketDetails">
        <el-form :model="formTicket" ref="ruleFormTicket" :rules="rulesTicket" label-width="120px">
          <div class="ticket-form">
            <div class="ticket-form-left">
              <!-- 门票名称 -->
              <el-form-item label="门票名称" prop="ticketName">
                <el-input v-model="formTicket.ticketName" size="small"></el-input>
              </el-form-item>

              <!-- 门票说明 -->
              <el-form-item label="门票说明" prop="ticketDescription">
                <el-input type="textarea" v-model="formTicket.ticketDescription" size="small" placeholder="请输入门票说明"></el-input>
              </el-form-item>

              <!-- 售票时间 -->
              <el-form-item label="售票开始时间" prop="startTime">
                <el-date-picker v-model="formTicket.startTime" type="datetime" size="small" placeholder="选择开始售票时间"></el-date-picker>
              </el-form-item>
              
              <el-form-item label="售票结束时间" prop="endTime">
                <el-date-picker v-model="formTicket.endTime" type="datetime" size="small" placeholder="选择结束售票时间"></el-date-picker>
              </el-form-item>
            </div>

            <div class="ticket-form-right">
              <!-- 门票价格 -->
              <el-form-item label="门票价格" prop="ticketPrice">
                <el-input v-model="formTicket.ticketPrice" size="small" style="width: 240px;">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>

              <!-- 门票数量 -->
              <el-form-item label="门票数量" prop="ticketQuantity">
                <el-input v-model="formTicket.ticketQuantity" size="small" style="width: 240px;"></el-input>
              </el-form-item>

              <!-- 启用状态-->
              <el-form-item label="启用状态" prop="status">
                <el-switch v-model="formTicket.status" active-text="启用" inactive-text="禁用"></el-switch>
              </el-form-item>
              
              <!-- 显示售票数量 -->
              <el-form-item label="显示售票数量" prop="showQuantity">
                <el-switch v-model="formTicket.showQuantity" active-text="显示" inactive-text="隐藏"></el-switch>
                <span class="form-item-hint">设置是否在前端展示已售票数量</span>
              </el-form-item>
              
              <!-- 显示售票时间 -->
              <el-form-item label="显示售票时间" prop="showTime">
                <el-switch v-model="formTicket.showTime" active-text="显示" inactive-text="隐藏"></el-switch>
                <span class="form-item-hint">设置是否在前端展示售票开始/结束时间</span>
              </el-form-item>
            </div>
          </div>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleTicketDetails = false">取消</el-button>
          <el-button type="primary" @click="saveTicket('ruleFormTicket')">确定</el-button>
        </span>
      </el-dialog>

      <!-- 添加子页面管理对话框 -->
      <el-dialog width="900px" :title="'页面管理 - ' + currentSiteName" :visible.sync="dialogVisiblePages">
        <div style="margin-bottom: 20px; display: flex; justify-content: space-between;">
          <span style="font-size: 14px; color: #666;">管理当前微站的所有页面</span>
          <el-button type="primary" size="small" @click="addPage">添加页面</el-button>
        </div>

        <el-table :data="sitePages" style="width: 100%">
          <el-table-column label="页面标题" prop="name" min-width="180" />
          <el-table-column label="首页" width="80">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.site_home" size="mini" type="success">首页</el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="更新时间" width="160">
            <template slot-scope="scope">
              {{ formatDate(scope.row.updatedAt) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="280">
            <template slot-scope="scope">
              <div style="display: flex; gap: 8px;">
                <el-button size="mini" type="primary" @click="editPageTitle(scope.row)">编辑标题</el-button>
                <el-button size="mini" type="success" @click="editPageContent(scope.row)">编辑内容</el-button>
                <el-button 
                  size="mini" 
                  type="danger" 
                  @click="deletePage(scope.row)"
                  :disabled="scope.row.site_home">
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 无数据提示-->
        <div v-if="sitePages.length === 0" style="text-align: center; padding: 30px;">
          <i class="el-icon-document" style="font-size: 48px; color: #dcdfe6;"></i>
          <p style="color: #909399;">暂无页面，请点击"添加页面"按钮创建</p>
        </div>
      </el-dialog>

      <!-- 页面标题编辑对话框-->
      <el-dialog width="30%" title="编辑页面标题" :visible.sync="dialogVisiblePageTitle">
        <el-form :model="currentPage" ref="pageForm">
          <el-form-item label="页面标题" prop="name" :rules="[{ required: true, message: '请输入页面标题', trigger: 'blur' }]">
            <el-input v-model="currentPage.name" placeholder="请输入页面标题"></el-input>
          </el-form-item>
          <el-form-item label="设为首页">
            <el-switch v-model="currentPage.site_home"></el-switch>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisiblePageTitle = false">取消</el-button>
          <el-button type="primary" @click="savePageTitle('pageForm')">保存</el-button>
        </span>
      </el-dialog>

      <!-- 门票用户列表弹窗 -->
      <el-dialog
        title="门票用户列表"
        :visible.sync="showTicketUserDialog"
        width="80%"
        :before-close="handleTicketUserDialogClose"
      >
        <!--<div class="ticket-user-filter" style="margin-bottom: 15px;">
          <el-select v-model="ticketUserPaymentFilter" placeholder="支付状态筛选" @change="handlePaymentFilterChange" style="width: 150px; margin-right: 15px;">
            <el-option label="全部状态" :value="null"></el-option>
            <el-option label="未支付" value="unpaid"></el-option>
            <el-option label="已支付" value="paid"></el-option>
            <el-option label="支付失败" value="failed"></el-option>
            <el-option label="已退款" value="refunded"></el-option>
          </el-select>
          <el-button size="small" type="primary" @click="exportTicketUsers">导出用户</el-button>
        </div>-->
        
        <el-table
          v-loading="ticketUsersLoading"
          :data="ticketUserList"
          style="width: 100%"
        >
          <el-table-column
            label="用户信息"
            min-width="160"
          >
            <template slot-scope="scope">
              <div class="user-info-cell">
                <el-avatar :size="40" :src="scope.row.avatar"></el-avatar>
                <div class="user-details">
                  <div>{{ scope.row.nickname }}</div>
                  <div v-if="scope.row.phone" style="font-size: 12px; color: #909399;">{{ scope.row.phone }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column
            prop="purchaseDate"
            label="提交时间"
            min-width="160"
          ></el-table-column>
          
          <el-table-column
            prop="status"
            label="状态"
            min-width="100"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 'completed' ? 'success' : 'info'">
                {{ scope.row.status === 'completed' ? '完成' : 
                   scope.row.status === 'pending' ? '等待中' : scope.row.status }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column
            prop="paymentStatus"
            label="支付状态"
            min-width="100"
          >
            <template slot-scope="scope">
              <el-tag :type="getPaymentStatusType(scope.row.paymentStatus)">
                {{ getPaymentStatusText(scope.row.paymentStatus) }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column
            label="操作"
            min-width="120"
          >
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small" 
                @click="viewUserFormData(scope.row)"
              >查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <div style="margin-top: 20px; text-align: right;">
          <el-pagination
            @size-change="handleTicketUsersSizeChange"
            @current-change="handleTicketUsersCurrentChange"
            :current-page="ticketUsersPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="ticketUsersPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="ticketUsersTotal"
          >
          </el-pagination>
        </div>
      </el-dialog>

      <!-- 表单数据详情弹窗 -->
      <el-dialog
        title="表单数据详情"
        :visible.sync="showFormDataDialog"
        width="60%"
      >
        <div v-if="currentFormData">
          <div v-for="(value, key) in currentFormData" :key="key" class="form-data-item">
            <div class="form-data-label">{{ key }}:</div>
            <div class="form-data-value">{{ value }}</div>
          </div>
        </div>
        <div v-else class="empty-form-data">
          无表单数据
        </div>
      </el-dialog>
      
      <!-- 模板选择对话框 -->
      <el-dialog
        title="选择模板"
        :visible.sync="showTemplateSelect"
        width="900px"
        :before-close="() => { showTemplateSelect = false; }"
      >
        <div class="template-list">
          <div 
            v-for="template in siteTemplates" 
            :key="template.id"
            class="template-item"
            @click="selectTemplate(template.id)"
          >
            <div class="template-preview">
              <img :src="template.previewUrl" :alt="template.name" class="template-image" />
            </div>
            <div class="template-title">{{ template.name }}</div>
          </div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { getShareSetting, setShareSetting } from "@/api/material";
import { editProject, getProjectById } from "@/api/project";
import { getSiteTypeList, saveSiteType, delSiteType, getSiteSortList } from "@/api/material";
import QRCode from "@chenfengyuan/vue-qrcode";
import { ticketList, ticketSave, ticketView, ticketDelete, getFormList, getTicketUsers } from "@/api/material";
import { getSiteTicketStatus, updateSiteTicketStatus } from "@/api/material";
import { format } from "date-fns";
import SiteTypeMenu from "./pages-manage/components/SiteTypeMenu.vue";
import global from "@/config/global";

export default {
  components: {
    'qrcode': QRCode,
    SiteTypeMenu
  },
  data() {
    const validatePrice = (rule, value, callback) => {
      const reg = /^\d+(\.\d{1,2})?$/;
      if (value === '') {
        callback();
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的价格格式，最多两位小数'));
      } else {
        callback();
      }
    };
    
    const validateQuantity = (rule, value, callback) => {
      const reg = /^\d+$/;
      if (value === '') {
        callback();
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的整数数量'));
      } else {
        callback();
      }
    };
    
    return {
      siteTypeList: [],
      loading: true,
      currentSiteId: "",
      defaultCover: "https://fankeymice.com/uploads/img/1742650854061_70.jpg",
      
      // 分类相关
      category: "",
      subCategory: "",
      categoryOptions: [], // 分类选项
      subCategoryOptions: [], // 子分类选项
      
      // 站点相关
      dialogVisible: false,
      dialogTitle: "添加微站",
      currentSite: {
        _id: null,
        name: "",
        cover: "",
        isHome: false,
        viewCount: 0,
        updatedAt: new Date(),
        createdAt: new Date(),
        description: "",
        status: 1,
        category: "",
        subCategory: ""
      },
      
      // 分享设置
      dialogVisibleShare: false,
      dialogTitleShare: "分享设置",
      shareData: {
        title: "",
        icon: "",
        description: "",
        formId: "",
        site_switch: '1'
      },
      
      // 表单相关
      formOptions: [],
      formLoading: false,
      formDialogVisible: false,
      formDialogtitle: "",
      formDialogUrl: "",
      
      // 门票相关
      dialogVisibleTicket: false,
      dialogVisibleTicketDetails: false,
      dialogTitleTicket: "门票管理",
      dialogTitleTicketDetails: "",
      formTicket: {
        ticketName: '',
        ticketDescription: '',
        startTime: '',
        endTime: '',
        ticketPrice: '',
        ticketQuantity: '',
        status: false,
        showQuantity: false,
        showTime: false,
      },
      rulesTicket: {
        ticketName: [{ required: true, message: '请输入门票名', trigger: 'blur' }],
        ticketPrice: [
          { required: true, message: '请输入门票价', trigger: 'blur' },
          { validator: validatePrice, trigger: 'blur' }
        ],
        ticketQuantity: [
          { required: true, message: '请输入门票数', trigger: 'blur' },
          { validator: validateQuantity, trigger: 'blur' }
        ],
        startTime: [{ required: true, message: '请选择开始售票时间', trigger: 'change' }],
        endTime: [{ required: true, message: '请选择结束售票时间', trigger: 'change' }],
      },
      ticketListData: [],
      siteTicketEnabled: false,
      currentSiteName: "",
      sitePages: [],
      dialogVisiblePages: false,
      dialogVisiblePageTitle: false,
      currentPage: {
        name: "",
        site_home: false,
        updatedAt: new Date()
      },
      dialogVisibleTicketUsers: false,
      currentTicket: null,
      ticketUserList: [],
      ticketUsersLoading: false,
      ticketUsersPage: 1,
      ticketUsersPageSize: 10,
      ticketUsersTotal: 0,
      ticketUserPaymentFilter: null,
      showTicketUserDialog: false,
      showFormDataDialog: false,
      currentFormData: null,
      // 模板相关状态
      selectedTemplateId: null,
      showTemplateSelect: false,
      siteTemplates: [],
    };
  },
  computed: {
    ...mapGetters(["project"])
  },
  created() {
    this.getSiteList();
  },
  mounted() {
    // 加载预设模板
    this.loadSiteTemplates();
  },
  methods: {
    ...mapMutations(["setCurPage", "setProject"]),
    
    openForm() {
      this.formDialogVisible = true;
      this.formDialogtitle = '表单管理';
      this.formDialogUrl = `${global.formUrl}/admin/survey?skip_auth=1`;
    },
    
    // 分类菜单变化处理
    onChangeMenu({ id, cid }) {
      // 当id和cid都为undefined时，表示选择了"全部"
      if (id === void 0 && cid === void 0) {
        this.category = "";
        this.subCategory = "";
      } else {
        this.category = id;
        this.subCategory = cid;
      }
      this.getSiteList();
    },
    
    // 获取分类选项
    async getCategoryOptions() {
      try {
        const { status, data, message } = await getSiteSortList({
          page: 1,
          pageSize: 100,
        });
        if (status == '10000') {
          this.categoryOptions = data.categories;
        } else {
          this.$message.error(message || '获取分类失败');
        }
      } catch (error) {
        console.error('获取分类失败:', error);
        this.$message.error('获取分类失败，请重试');
      }
    },
    
    // 设置子分类选项
    async setSubCategoryOptions(categoryId) {
      if (!categoryId) {
        this.subCategoryOptions = [];
        return;
      }
      
      // 根据选中的分类ID找到对应的分类对象
      const selectedCategory = this.categoryOptions.find(item => item._id === categoryId);
      
      // 设置子分类选项
      if (selectedCategory && selectedCategory.child && selectedCategory.child.length > 0) {
        this.subCategoryOptions = [...selectedCategory.child];
      } else {
        this.subCategoryOptions = [];
      }
    },
    
    // 处理分类变化
    async handleCategoryChange(categoryId) {
      // 清空子分类选择
      this.currentSite.subCategory = '';
      
      // 设置新的子分类选项
      await this.setSubCategoryOptions(categoryId);
    },
    
    // 格式化日期
    formatDate(date) {
      if (!date) return '';
      try {
        return format(new Date(date), 'yyyy-MM-dd HH:mm');
      } catch (error) {
        console.error('Date formatting error:', error);
        return '';
      }
    },
    
    // 获取站点URL
    getSiteUrl(siteId) {
      // 查找该微站的首页
      const sitePages = this.project.pages.filter(page => page.site === siteId);
      const homePage = sitePages.find(page => page.site_home === true);
      const pid = this.project && this.project._id ? this.project._id : '';
      
      if (homePage) {
        // 如果找到首页，生成基于pageId的链接，使用配置文件中的viewUrl
        return `${global.viewUrl}pages/index/custom/custom?pageId=${homePage.id}${pid ? `&id=${pid}` : ''}&siteId=${siteId}`;
      } else if (sitePages.length > 0) {
        // 如果没有首页但有其他页面，使用第一个页面
        return `${global.viewUrl}pages/index/custom/custom?pageId=${sitePages[0].id}${pid ? `&id=${pid}` : ''}&siteId=${siteId}`;
      } else {
        // 如果没有页面，返回站点ID的链接（兜底方案）
        const baseUrl = window.location.origin;
        return `${baseUrl}/site/${siteId}${pid ? `?id=${pid}` : ''}`;
      }
    },
    
    // 复制站点URL到剪贴板
    copySiteUrl(siteId) {
      const url = this.getSiteUrl(siteId);
      const textArea = document.createElement('textarea');
      textArea.value = url;
      document.body.appendChild(textArea);
      textArea.select();
      
      try {
        document.execCommand('copy');
        this.$message.success('链接已复制到剪贴板');
      } catch (err) {
        this.$message.error('复制失败，请手动复制');
        console.error('复制失败:', err);
      }
      
      document.body.removeChild(textArea);
    },
    
    // 预览站点
    previewSite(siteId) {
      const url = this.getSiteUrl(siteId);
      window.open(url, '_blank');
    },
    
    // 获取站点列表
    async getSiteList() {
      this.loading = true;
      try {
        const params = {};
        // 只有在有分类时才添加筛选条件
        if (this.category) {
          params.category = this.category;
        }
        if (this.subCategory) {
          params.subCategory = this.subCategory;
        }
        
        const { status, data, message } = await getSiteTypeList(params);
        if (status == '10000') {
          // 确保 data 是数组格式
          if (Array.isArray(data)) {
            this.siteTypeList = data.map(site => ({
              ...site,
              cover: site.cover || this.defaultCover,
              viewCount: site.viewCount || 0
            }));
          } else {
            console.warn('站点列表数据格式异常:', data);
            this.siteTypeList = [];
            this.$message.warning('站点列表数据格式异常');
          }
        } else {
          this.$message.error(message || '获取站点列表失败');
        }
      } catch (error) {
        console.error('获取站点列表失败:', error);
        this.$message.error('获取站点列表失败');
      } finally {
        this.loading = false;
      }
    },
    
    // 加载预设模板
    loadSiteTemplates() {
      import('@/config/site-templates').then(({ siteTemplates }) => {
        this.siteTemplates = siteTemplates;
      }).catch(error => {
        console.error('加载模板失败:', error);
      });
    },
    
    // 添加微站
    async addSite() {
      // 初始化微站数据
      this.currentSite = {
        _id: null,
        name: "",
        cover: "",
        isHome: false,
        viewCount: 0,
        updatedAt: new Date(),
        createdAt: new Date(),
        description: "",
        status: 1,
        category: this.category || '', // 默认使用当前选中的分类
        subCategory: '' // 默认子分类为空
      };
      
      // 获取分类选项
      await this.getCategoryOptions();
      
      // 如果有默认分类，设置子分类选项
      if (this.currentSite.category) {
        await this.setSubCategoryOptions(this.currentSite.category);
      } else {
        this.subCategoryOptions = [];
      }
      
      // 显示模板选择对话框
      this.showTemplateSelect = true;
    },
    
    // 选择模板
    selectTemplate(templateId) {
      this.selectedTemplateId = templateId;
      this.showTemplateSelect = false;
      // 设置对话框标题
      this.dialogTitle = "添加微站";
      // 显示微站创建表单
      this.dialogVisible = true;
    },
    
    // 编辑微站
    editSite(site) {
      this.currentSiteId = site._id;
      
      // 查找项目中与当前微站关联的页面，优先查找首页
      const sitePages = this.project.pages.filter(page => page.site === site._id);
      const homePage = sitePages.find(page => page.site_home === true);
      
      if (homePage) {
        // 如果找到首页，直接设置为当前页面并导航到编辑界面
        this.setCurPage(homePage);
        this.$router.push({ name: "page-build" });
      } else if (sitePages.length > 0) {
        // 如果没有首页但有其他页面，使用第一个页面
        this.setCurPage(sitePages[0]);
        this.$router.push({ name: "page-build" });
      } else {
        // 只有在找不到任何相关页面时，才创建新页面
        // 注意：这里不应该创建默认页面，应该让用户选择模板或使用空页面
        // 避免覆盖已选择的模板结构
        this.$message.warning('该微站暂无页面，请先创建页面');
        console.warn('微站没有页面，避免自动创建默认页面覆盖模板结构');
      }
    },
    
    // 创建新页面并导航到编辑页
    async createNewPage(siteId) {
      try {
        const newPage = {
                          "id": this.generateUniqueId(),
                          "name": "微站首页",
                          "site": siteId,
                          "site_home": true,
                          "viewCount": 0,
                          "updatedAt": "2025-03-22T14:05:20.578Z",
                          "componentList": [
                              {
                                  "component": "McImg",
                                  "name": "图片",
                                  "icon": "icon-image",
                                  "imageValue": {
                                      "imagePath": "https://fankeymice.com/uploads/img/1742650854061_70.jpg"
                                  },
                                  "imageStyle": {
                                      "pagePadding": 0,
                                      "cmpRadius": 0,
                                      "cmpUpperPadding": 0,
                                      "cmpLowerPadding": 0
                                  },
                                  "id": "2652320578T6d4th",
                                  "height": 210
                              },
                              {
                                  "component": "McModuleContainer",
                                  "name": "模块容器",
                                  "icon": "icon-zhijiao",
                                  "styles": {
                                      "backgroundColor": "rgba(228, 228, 228, 0)",
                                      "backgroundImage": "",
                                      "borderRadius": 8,
                                      "margin": 10,
                                      "padding": 15,
                                      "height": 100,
                                      "shape": "normal"
                                  },
                                  "moduleType": "grid",
                                  "modules": [
                                      {
                                          "title": "会场直播",
                                          "subtitle": "",
                                          "backgroundColor": "#ffffff",
                                          "fontColor": "#333333",
                                          "linkType": "live",
                                          "linkUrl": "",
                                          "content": "",
                                          "images": [
                                              {
                                                  "_id": "67f543be772a192fb475a35d",
                                                  "id": "67f543be772a192fb475a35d",
                                                  "title": "素材1",
                                                  "url": "https://fankeymice.com/uploads/img/1744126592485_432.jpg",
                                                  "publishTime": "2025-04-08 23:41",
                                                  "content": "https://fankeymice.com/uploads/img/1744126592485_432.jpg"
                                              }
                                          ],
                                          "videos": [],
                                          "documents": [],
                                          "liveUrl": "",
                                          "time": "",
                                          "status": "upcoming",
                                          "description": "",
                                          "source": "",
                                          "publishTimeDate": "",
                                          "publishTime": "",
                                          "coverImage": "",
                                          "imagesConfig": {
                                              "dataSource": "dynamic",
                                              "max": "2",
                                              "selectedImageIds": [],
                                              "tabs": [],
                                              "images": [
                                                  {
                                                      "_id": "67f543be772a192fb475a35d",
                                                      "id": "67f543be772a192fb475a35d",
                                                      "title": "素材1",
                                                      "url": "https://fankeymice.com/uploads/img/1744126592485_432.jpg",
                                                      "publishTime": "2025-04-08 23:41",
                                                      "content": "https://fankeymice.com/uploads/img/1744126592485_432.jpg"
                                                  }
                                              ]
                                          },
                                          "icon": "https://fankeymice.com/uploads/img/1744205866887_37.png",
                                          "tabs": [],
                                          "liveConfig": {
                                              "dataSource": "existing",
                                              "style": "list",
                                              "max": "2",
                                              "liveList": [],
                                              "selectedLiveIds": [],
                                              "tabs": [
                                                  {
                                                      "checked": true,
                                                      "_id": "67c5506ea67c2a31a0528335",
                                                      "name": "公开课",
                                                      "type": "",
                                                      "description": "",
                                                      "createdAt": "2025-03-03T06:47:10.842Z",
                                                      "child": [
                                                          {
                                                              "checked": true,
                                                              "_id": "67c5530aa67c2a31a0528338",
                                                              "id": "67c5530aa67c2a31a0528337",
                                                              "parentId": "67c5506ea67c2a31a0528335",
                                                              "name": "难治性肠癌学院",
                                                              "type": "",
                                                              "description": "",
                                                              "createdAt": "2025-03-03T06:58:18.344Z"
                                                          },
                                                          {
                                                              "checked": true,
                                                              "_id": "67c5538aa67c2a31a052833b",
                                                              "id": "67c5538aa67c2a31a052833a",
                                                              "parentId": "67c5506ea67c2a31a0528335",
                                                              "name": "介入万里行",
                                                              "type": "",
                                                              "description": "",
                                                              "createdAt": "2025-03-03T07:00:26.955Z"
                                                          }
                                                      ],
                                                      "__v": 2
                                                  },
                                                  {
                                                      "checked": true,
                                                      "_id": "67c71d438f6e371f686ce0ba",
                                                      "name": "测试",
                                                      "type": "",
                                                      "description": "",
                                                      "createdAt": "2025-03-04T15:33:23.954Z",
                                                      "child": [
                                                          {
                                                              "checked": true,
                                                              "_id": "67cd2d321af6783e6caf2845",
                                                              "id": "67cd2d321af6783e6caf2844",
                                                              "parentId": "67c71d438f6e371f686ce0ba",
                                                              "name": "test2",
                                                              "type": "",
                                                              "description": "",
                                                              "createdAt": "2025-03-09T05:54:58.022Z"
                                                          }
                                                      ],
                                                      "__v": 2
                                                  }
                                              ],
                                              "itemPadding": 10
                                          }
                                      },
                                      {
                                          "title": "新闻资讯",
                                          "subtitle": "",
                                          "backgroundColor": "#ffffff",
                                          "fontColor": "#333333",
                                          "linkType": "news",
                                          "linkUrl": "",
                                          "content": "",
                                          "images": [],
                                          "videos": [],
                                          "documents": [],
                                          "liveUrl": "",
                                          "time": "",
                                          "status": "upcoming",
                                          "description": "",
                                          "source": "",
                                          "publishTimeDate": "",
                                          "publishTime": "",
                                          "coverImage": "",
                                          "newsConfig": {
                                              "dataSource": "existing",
                                              "style": "list",
                                              "max": "2",
                                              "selectedNewsIds": [],
                                              "newsList": [],
                                              "tabs": [
                                                  {
                                                      "_id": "670e74efaf089a40acf16ade",
                                                      "name": "新闻分类1",
                                                      "parentId": "670e74efaf089a40acf16add",
                                                      "parentName": "新闻"
                                                  },
                                                  {
                                                      "_id": "6770d88ac418fd20744dd00e",
                                                      "name": "新闻分类2",
                                                      "parentId": "670e74efaf089a40acf16add",
                                                      "parentName": "新闻"
                                                  }
                                              ]
                                          },
                                          "icon": "https://fankeymice.com/uploads/img/1744205844595_692.png"
                                      },
                                      {
                                          "title": "图片集",
                                          "subtitle": "",
                                          "icon": "https://fankeymice.com/uploads/img/1744518671657_807.png",
                                          "backgroundColor": "#ffffff",
                                          "fontColor": "#333333",
                                          "linkType": "images",
                                          "linkUrl": "",
                                          "content": "",
                                          "images": [],
                                          "videos": [],
                                          "documents": [],
                                          "liveUrl": "",
                                          "time": "",
                                          "status": "upcoming",
                                          "description": "",
                                          "source": "",
                                          "publishTimeDate": "",
                                          "publishTime": "",
                                          "coverImage": "",
                                          "imagesConfig": {
                                              "dataSource": "existing",
                                              "max": 1,
                                              "tabs": [],
                                              "imageList": [],
                                              "selectedImageIds": [],
                                              "columns": 2
                                          }
                                      },
                                      {
                                          "title": "视频集",
                                          "subtitle": "",
                                          "icon": "https://fankeymice.com/uploads/img/1744292602130_505.png",
                                          "backgroundColor": "#ffffff",
                                          "fontColor": "#333333",
                                          "linkType": "videos",
                                          "linkUrl": "",
                                          "content": "",
                                          "images": [],
                                          "videos": [],
                                          "documents": [],
                                          "liveUrl": "",
                                          "time": "",
                                          "status": "upcoming",
                                          "description": "",
                                          "source": "",
                                          "publishTimeDate": "",
                                          "publishTime": "",
                                          "coverImage": "",
                                          "videoConfig": {
                                              "dataSource": "dynamic",
                                              "videoList": [],
                                              "max": "2",
                                              "tabs": [
                                                  {
                                                      "_id": "670e74efaf089a40acf16adc",
                                                      "name": "视频分类1",
                                                      "description": "",
                                                      "materials": [
                                                          {
                                                              "_id": "67ce9a47831136159c8aaffe",
                                                              "title": "测试视频",
                                                              "category": "670e74efaf089a40acf16adb",
                                                              "subCategory": "670e74efaf089a40acf16adc",
                                                              "cover": "https://fankeymice.com/uploads/img/1741593138954_191.jpg",
                                                              "content": "https://fankeymice.com/uploads/video/1741593155763_605.mp4",
                                                              "createdAt": "2025-03-10 15:52",
                                                              "updatedAt": "2025-03-10 15:52",
                                                              "__v": 0
                                                          }
                                                      ],
                                                      "totalMaterials": 1,
                                                      "currentPage": 1,
                                                      "totalPages": 1
                                                  },
                                                  {
                                                      "_id": "6758678e06e1864578936098",
                                                      "name": "视频1",
                                                      "materials": [
                                                          {
                                                              "_id": "67cc307326d42c1ef4310327",
                                                              "title": "测试视频",
                                                              "category": "670e74efaf089a40acf16adb",
                                                              "subCategory": "6758678e06e1864578936098",
                                                              "cover": "https://fankeymice.com/uploads/img/1741434979393_114.jpg",
                                                              "content": "https://fankeymice.com/uploads/video/1741434992609_550.mp4",
                                                              "createdAt": "2025-03-08 19:56",
                                                              "updatedAt": "2025-03-08 19:56",
                                                              "__v": 0
                                                          },
                                                          {
                                                              "_id": "67cea44f831136159c8aafff",
                                                              "title": "测试竖屏",
                                                              "category": "670e74efaf089a40acf16adb",
                                                              "subCategory": "6758678e06e1864578936098",
                                                              "cover": "https://fankeymice.com/uploads/img/1741595709353_858.jpg",
                                                              "content": "https://fankeymice.com/uploads/video/1741595716553_354.mp4",
                                                              "createdAt": "2025-03-10 16:35",
                                                              "updatedAt": "2025-03-10 16:35",
                                                              "__v": 0
                                                          }
                                                      ],
                                                      "totalMaterials": 2,
                                                      "currentPage": 1,
                                                      "totalPages": 1
                                                  }
                                              ],
                                              "selectedVideoIds": []
                                          },
                                          "videosConfig": {
                                              "dataSource": "existing",
                                              "style": "list",
                                              "max": "2",
                                              "selectedVideoIds": [],
                                              "videoList": [],
                                              "tabs": [],
                                              "type": "static",
                                              "columns": 2
                                          }
                                      },
                                      {
                                          "title": "文档中心",
                                          "subtitle": "",
                                          "icon": "https://fankeymice.com/uploads/img/1744522418988_45.png",
                                          "backgroundColor": "#ffffff",
                                          "fontColor": "#333333",
                                          "linkType": "documents",
                                          "linkUrl": "",
                                          "content": "",
                                          "images": [],
                                          "videos": [],
                                          "documents": [],
                                          "liveUrl": "",
                                          "time": "",
                                          "status": "upcoming",
                                          "description": "",
                                          "source": "",
                                          "publishTimeDate": "",
                                          "publishTime": "",
                                          "coverImage": "",
                                          "documentsConfig": {
                                              "dataSource": "existing",
                                              "documentList": [],
                                              "selectedDocumentIds": [],
                                              "tabs": [
                                                  {
                                                      "_id": "67717deefe4b04219cae98cf",
                                                      "name": "test"
                                                  }
                                              ],
                                              "columns": 1
                                          }
                                      },
                                      {
                                          "title": "合作伙伴",
                                          "subtitle": "",
                                          "icon": "https://fankeymice.com/uploads/img/1744538926705_903.png",
                                          "backgroundColor": "#ffffff",
                                          "fontColor": "#333333",
                                          "linkType": "partners",
                                          "linkUrl": "",
                                          "content": "",
                                          "images": [
                                              {
                                                  "id": "67f543be772a192fb475a35d",
                                                  "title": "素材1",
                                                  "url": "https://fankeymice.com/uploads/img/1744126592485_432.jpg",
                                                  "content": "https://fankeymice.com/uploads/img/1744126592485_432.jpg",
                                                  "cover": "https://fankeymice.com/uploads/img/1744126592485_432.jpg",
                                                  "path": "https://fankeymice.com/uploads/img/1744126592485_432.jpg",
                                                  "description": "",
                                                  "publishTime": "2025-04-13T10:39:37.225Z"
                                              },
                                              {
                                                  "id": "67fb8d4f772a192fb475a36d",
                                                  "title": "E健云",
                                                  "url": "https://fankeymice.com/uploads/img/1744538957251_961.png",
                                                  "content": "https://fankeymice.com/uploads/img/1744538957251_961.png",
                                                  "cover": "https://fankeymice.com/uploads/img/1744538957251_961.png",
                                                  "path": "https://fankeymice.com/uploads/img/1744538957251_961.png",
                                                  "description": "",
                                                  "publishTime": "2025-04-13T10:39:37.226Z"
                                              }
                                          ],
                                          "videos": [],
                                          "documents": [],
                                          "liveUrl": "",
                                          "time": "",
                                          "status": "upcoming",
                                          "description": "",
                                          "source": "",
                                          "publishTimeDate": "",
                                          "publishTime": "",
                                          "coverImage": "",
                                          "partnersConfig": {
                                              "dataSource": "existing",
                                              "style": "grid",
                                              "columns": 2,
                                              "autoplay": false,
                                              "interval": 3000,
                                              "max": 12,
                                              "partnerList": [],
                                              "selectedPartnerIds": [],
                                              "tabs": [],
                                              "partnersList": []
                                          },
                                          "partners": [],
                                          "imagesConfig": {
                                              "dataSource": "existing",
                                              "style": "grid",
                                              "columns": "2",
                                              "autoplay": false,
                                              "interval": 3000,
                                              "max": 6,
                                              "imageList": [
                                                  {
                                                      "id": "67f543be772a192fb475a35d",
                                                      "title": "素材1",
                                                      "url": "https://fankeymice.com/uploads/img/1744126592485_432.jpg",
                                                      "content": "https://fankeymice.com/uploads/img/1744126592485_432.jpg",
                                                      "cover": "https://fankeymice.com/uploads/img/1744126592485_432.jpg",
                                                      "path": "https://fankeymice.com/uploads/img/1744126592485_432.jpg",
                                                      "description": "",
                                                      "publishTime": "2025-04-13T10:39:37.225Z"
                                                  },
                                                  {
                                                      "id": "67fb8d4f772a192fb475a36d",
                                                      "title": "E健云",
                                                      "url": "https://fankeymice.com/uploads/img/1744538957251_961.png",
                                                      "content": "https://fankeymice.com/uploads/img/1744538957251_961.png",
                                                      "cover": "https://fankeymice.com/uploads/img/1744538957251_961.png",
                                                      "path": "https://fankeymice.com/uploads/img/1744538957251_961.png",
                                                      "description": "",
                                                      "publishTime": "2025-04-13T10:39:37.226Z"
                                                  }
                                              ],
                                              "selectedImageIds": [
                                                  "67f543be772a192fb475a35d",
                                                  "67fb8d4f772a192fb475a36d"
                                              ],
                                              "tabs": []
                                          }
                                      }
                                  ],
                                  "id": "1743772310cSTPxr",
                                  "height": 135
                              },
                              {
                                  "component": "McTitle",
                                  "name": "标题",
                                  "icon": "icon-biaotizujian",
                                  "value": {
                                      "title": "",
                                      "info": "E健云技术支持"
                                  },
                                  "attrs": {
                                      "model": "center"
                                  },
                                  "styles": {
                                      "pagePadding": 0,
                                      "cmpUpperPadding": 0,
                                      "cmpLowerPadding": 0,
                                      "cmpUpperRadius": 0,
                                      "cmpLowerRadius": 0,
                                      "titleSize": 10,
                                      "infoSize": 12,
                                      "titleColor": "#333333",
                                      "infoColor": "#999999",
                                      "cmpBackground": ""
                                  },
                                  "id": "2652320578pPzHhz",
                                  "height": 40
                              }
                          ],
                          "schema": {
                              "type": "template",
                              "components": []
                          }
                      }

        // console.log(newPage)
        // return
        
        // 添加到项目中
        this.project.pages.push(newPage);
        
        // 保存项目 - 先设置当前页面，确保即使保存失败也能进入编辑模式，稍后可以重试保存
        this.setCurPage(newPage);
        
        // 尝试保存项目
        const saveResult = await this.saveProject();
        if (!saveResult) {
          // 如果保存失败但不影响用户体验，仍然允许进入编辑模式，稍后可以重试保存
          console.warn('项目保存失败，但已进入编辑模式，稍后可重试保存');
        }
        
        // 导航到编辑界面
        this.$router.push({ name: "page-build" });
      } catch (error) {
        console.error('创建新页面失败:', error);
        this.$message.error('创建页面失败，请重试');
      }
    },
    
    // 生成唯一ID
    generateUniqueId() {
      return 'page_' + Date.now() + '_' + Math.floor(Math.random() * 1000);
    },
    
    // 生成组件ID
    generateComponentId(prefix) {
      return Date.now().toString().slice(-10) + this.getRandomString(6);
    },
    
    // 导入模板数据
    async importTemplateData(siteId, templateId) {
      try {
        // 从配置中获取模板结构
        const { getTemplateById } = await import('@/config/site-templates');
        const templateStructure = getTemplateById(templateId);
        
        if (!templateStructure) {
          throw new Error('未找到指定模板');
        }
        
        // 获取最新的项目数据
        await this.getLatestProjectData();
        
        // 创建首页
        const homePage = this.createHomePageFromTemplate(siteId, templateStructure.homePage);
        
        // 将首页添加到项目中
        if (!this.project.pages) {
          this.project.pages = [];
        }
        this.project.pages.push(homePage);
        
        // 保存项目配置
        await this.saveProject();
        
        console.log('模板导入成功');
      } catch (error) {
        console.error('导入模板数据失败:', error);
        throw error;
      }
    },
    
    // 从模板创建首页
    createHomePageFromTemplate(siteId, templateHomePage) {
      // 生成唯一ID
      const id = this.generateUniqueId();
      
      // 复制模板页面结构并修改必要的属性
      const page = {
        ...JSON.parse(JSON.stringify(templateHomePage)),
        id,
        site: siteId,
        updatedAt: new Date().toISOString(),
        createdAt: new Date().toISOString()
      };
      
      // 为每个组件生成唯一ID
      if (page.componentList && Array.isArray(page.componentList)) {
        page.componentList = page.componentList.map(comp => ({
          ...comp,
          id: this.generateComponentId()
        }));
      }
      
      return page;
    },
    
    // 生成随机字符串
    getRandomString(length) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return result;
    },
    
    // 保存微站
    saveSite(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            const isAdd = !this.currentSite._id;
            const params = {
              name: this.currentSite.name,
              cover: this.currentSite.cover || this.defaultCover,
              isHome: this.currentSite.isHome || false,
              viewCount: this.currentSite.viewCount || 0,
              updatedAt: new Date().toISOString(),
              createdAt: this.currentSite.createdAt || new Date().toISOString(),
              description: this.currentSite.description || '',
              status: this.currentSite.status || 1,
              category: this.currentSite.category || '',
              subCategory: this.currentSite.subCategory || ''
            };
            
            if (!isAdd) {
              params.id = this.currentSite._id;
            }
            
            const { status, message, data, id } = await saveSiteType(isAdd, params);
            
            if (status == '10000') {
              // 如果是新建微站且选择了模板
              if (isAdd && this.selectedTemplateId) {
                try {
                  // 检查响应中是否包含微站ID（后端可能返回在data对象中或直接返回id字段）
                  const siteId = data?._id || data?.id || id;
                  if (!siteId) {
                    console.warn('API响应中缺少微站ID，无法导入模板数据');
                    this.$message.warning('微站创建成功，但无法导入模板数据，将使用默认页面');
                  } else {
                    // 导入模板数据
                    await this.importTemplateData(siteId, this.selectedTemplateId);
                    // 导入成功后清空选中的模板
                    this.selectedTemplateId = null;
                  }
                } catch (templateError) {
                  console.error('导入模板失败:', templateError);
                  this.$message.warning('微站创建成功，但模板导入失败，将使用默认页面');
                }
              }
              
              this.$message.success(isAdd ? '添加成功' : '更新成功');
              this.dialogVisible = false;
              this.getSiteList();
            } else {
              this.$message.error(message || '操作失败');
            }
          } catch (error) {
            console.error('保存微站失败:', error);
            this.$message.error('保存失败，请重试');
          }
        }
      });
    },
    
    // 保存项目
    async saveProject() {
      try {
        const { status, message } = await editProject(this.project);
        if (status != 10000) {
          console.error('保存项目失败，状态码:', status, '信息:', message);
          this.$message.warning("自动保存失败，您可以继续编辑，稍后手动保存");
          return false;
        }
        return true;
      } catch (error) {
        console.error('保存项目异常:', error);
        this.$message.warning("自动保存失败，您可以继续编辑，稍后手动保存");
        return false;
      }
    },
    
    // 处理下拉命令
    handleCommand(command, param) {
      console.log('处理命令:', command, '参数:', param);
      
      if (command === "rename") {
        // 重命名微站
        this.dialogTitle = "重命名微站";
        this.currentSite = {
          _id: param._id,
          name: param.name,
          cover: param.cover || this.defaultCover,
          description: param.description || '',
          isHome: param.isHome || false,
          viewCount: param.viewCount || 0,
          status: param.status || 1,
          category: param.category || '',
          subCategory: param.subCategory || ''
        };
        
        // 获取分类选项并设置子分类
        this.getCategoryOptions().then(() => {
          if (this.currentSite.category) {
            this.setSubCategoryOptions(this.currentSite.category);
          }
        });
        
        this.dialogVisible = true;
      } else if (command === "setting") {
        // 基础设置
        this.openSettings(param);
      } else if (command === "ticket") {
        // 门票管理
        this.openTicketManagement(param);
      } else if (command === "manage") {
        // 页面管理 - 打开子页面管理对话框
        this.currentSiteName = param.name;
        this.currentSiteId = param._id;
        
        // 先获取最新的项目数据，再打开页面管理对话框
        this.getLatestProjectData().then(() => {
          this.dialogVisiblePages = true;
          this.getSitePages(param._id);
        });
      } else if (command === "delete") {
        // 删除微站
        this.deleteSite(param);
      } else if (command === "editTicket") {
        // 编辑门票 - 检查门票对象是否有效
        console.log('编辑门票:', param);
        if (param && typeof param === 'object' && (param.id || param._id)) {
          this.editTicket({
            id: param.id || param._id,
            ticketName: param.ticketName || '',
            ticketDescription: param.ticketDescription || '',
            startTime: param.startTime ? new Date(param.startTime) : '',
            endTime: param.endTime ? new Date(param.endTime) : '',
            ticketPrice: param.ticketPrice || '',
            ticketQuantity: param.ticketQuantity || '',
            status: param.status === 1 || param.status === true
          });
        } else {
          this.$message.error('无效的门票数据');
          console.error('无效的门票数据:', param);
        }
      } else if (command === "delTicket") {
        // 删除门票 - 检查门票对象是否有效
        console.log('删除门票:', param);
        if (param && typeof param === 'object' && (param.id || param._id)) {
          this.deleteTicket({
            id: param.id || param._id,
            siteId: this.currentSiteId
          });
        } else {
          this.$message.error('无效的门票数据');
          console.error('无效的门票数据:', param);
        }
      } else if (command === "viewTicketUsers") {
        // 查看门票用户列表
        this.viewTicketUsers(param);
      } else if (command === "changeCover") {
        // 更改封面
        this.changeCover(param);
      }
    },
    
    // 删除微站
    deleteSite(site) {
      this.$confirm("此操作将永久删除该微站及其所有页面，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        try {
          const { status, message } = await delSiteType({
            id: site._id
          });
          
          if (status == '10000') {
            this.$message.success("删除成功!");
            this.getSiteList();
          } else {
            this.$message.error(message || '删除失败');
          }
        } catch (error) {
          console.error('删除微站失败:', error);
          this.$message.error('删除失败，请重试');
        }
      }).catch(() => {
        console.info("已取消删除");
      });
    },
    
    // 封面上传成功
    handleCoverSuccess(res, file) {
      if (res.errorCode === '00000') {
        // 保存图片URL到当前站点对象
        this.currentSite.cover = res.data;
        
        // 检查图片是否能正常加载
        const img = new Image();
        img.onload = () => {
          console.log('封面图片加载成功:', res.data);
          this.$message.success('封面图片上传成功');
        };
        img.onerror = (e) => {
          console.error('封面图片加载失败:', e);
          this.$message.warning('图片可能无法正常显示，请尝试使用其他图片');
        };
        img.src = res.data;
      } else {
        this.$message.error(res.message || "上传失败，请重试");
      }
    },
    
    // 预览封面
    previewCover(coverUrl) {
      this.$alert(`<div style="text-align: center;"><img src="${coverUrl}" style="max-width: 100%; max-height: 400px; border-radius: 8px;" /></div>`, '封面预览', {
        dangerouslyUseHTMLString: true,
        customClass: 'cover-preview-dialog',
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: '关闭'
      });
    },
    
    // 删除封面
    removeCover() {
      this.$confirm('确定要删除当前封面吗？删除后将使用默认封面', '删除封面', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.currentSite.cover = '';
        this.$message.success('封面已删除');
      }).catch(() => {
        // 用户取消删除
      });
    },
    
    // 更改封面
    changeCover(site) {
      this.dialogTitle = "更改封面";
      this.currentSite = {
        _id: site._id,
        name: site.name,
        cover: site.cover || this.defaultCover,
        description: site.description || '',
        isHome: site.isHome || false,
        viewCount: site.viewCount || 0,
        status: site.status || 1,
        category: site.category || '',
        subCategory: site.subCategory || ''
      };
      
      // 获取分类选项并设置子分类
      this.getCategoryOptions().then(() => {
        if (this.currentSite.category) {
          this.setSubCategoryOptions(this.currentSite.category);
        }
      });
      
      this.dialogVisible = true;
    },
    
    // 封面图片加载成功
    handleCoverLoad(site) {
      this.$set(site, 'coverError', false);
    },
    
    // 封面图片加载失败
    handleCoverError(site) {
      this.$set(site, 'coverError', true);
    },
    
    // 封面上传前检查
    beforeCoverUpload(file) {
      // 检查文件类型
      const isImage = file.type.startsWith('image/');
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
      
      // 检查文件大小
      const isLt2M = file.size / 1024 / 1024 < 2;
      
      // 检查文件尺寸（可选）
      return new Promise((resolve, reject) => {
        if (!isImage) {
          this.$message.error('上传封面图片只能是图片格式');
          reject(false);
          return;
        }
        
        if (!isJpgOrPng) {
          this.$message.error('封面图片只支持 JPG、PNG 格式');
          reject(false);
          return;
        }
        
        if (!isLt2M) {
          this.$message.error('上传封面图片大小不能超过 2MB!');
          reject(false);
          return;
        }
        
        // 检查图片尺寸（可选优化）
        const img = new Image();
        img.onload = () => {
          const width = img.width;
          const height = img.height;
          
          // 建议尺寸检查（非强制）
          if (width < 400 || height < 200) {
            this.$message.warning('建议使用尺寸更大的图片（推荐 800×400px）以获得更好的显示效果');
          }
          
          resolve(true);
        };
        img.onerror = () => {
          // 如果无法读取图片尺寸，仍然允许上传
          resolve(true);
        };
        img.src = URL.createObjectURL(file);
      });
    },
    
    // 获取表单选项
    async getFormOptions() {
      try {
        this.formLoading = true;
        const response = await getFormList();
        console.log('Form list response:', response);
        
        if (response.status == '10000') {
          /**
           * API response structure:
           * {
           *   status: "10000",
           *   message: "获取问卷列表成功",
           *   data: {
           *     forms: [...],  // Array of form objects
           *     total: 20,
           *     page: 1,
           *     pageSize: 20,
           *     totalPages: 1
           *   }
           * }
           * 
           * Each form object has the structure:
           * {
           *   id: number,
           *   form_id: string,  // This is what we need for the form selection
           *   title: string,    // Display name for the form
           *   status: number,
           *   ...other properties
           * }
           */
          // Check if response contains forms in the nested data.forms structure
          if (response.data && response.data.forms && Array.isArray(response.data.forms)) {
            this.formOptions = response.data.forms;
          } else if (response.data && Array.isArray(response.data)) {
            this.formOptions = response.data;
          } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
            this.formOptions = response.data.data;
          } else {
            this.formOptions = [];
            console.warn('Unexpected form list data structure:', response.data);
          }
          
          console.log('Form options after assignment:', this.formOptions);
        } else {
          console.error('Failed to get form list:', response.message || 'Unknown error');
          this.formOptions = [];
        }
      } catch (error) {
        console.error('获取表单列表失败:', error);
        this.formOptions = [];
      } finally {
        this.formLoading = false;
      }
    },
    
    // 获取门票列表
    async getTicketList() {
      try {
        console.log('获取门票列表，站点ID:', this.currentSiteId);
        const response = await ticketList({ site_id: this.currentSiteId });
        console.log('门票列表响应:', response);
        
        if (response.status == '10000') {
          if (response.data && Array.isArray(response.data.list)) {
            // 添加调试输出，显示每张门票的所有属性值
            if (response.data.list.length > 0) {
              console.log('门票列表首个数据的所有属性:');
              const firstTicket = response.data.list[0];
              for (const key in firstTicket) {
                console.log(`${key}: ${firstTicket[key]} (类型: ${typeof firstTicket[key]})`);
              }
            }
            
            this.ticketListData = response.data.list.map(ticket => {
              // 确保状态字段被正确解析为布尔值
              const processedTicket = { ...ticket };
              
              // 显式转换布尔值
              processedTicket.status = ticket.status === true || ticket.status === 1 || ticket.status === 'true' || ticket.status === '1';
              processedTicket.showQuantity = ticket.showQuantity === true || ticket.showQuantity === 1 || ticket.showQuantity === 'true' || ticket.showQuantity === '1';
              processedTicket.showTime = ticket.showTime === true || ticket.showTime === 1 || ticket.showTime === 'true' || ticket.showTime === '1';
              
              console.log(`处理门票 ${ticket._id} 的状态字段:`, {
                原status: ticket.status,
                转换后status: processedTicket.status,
                原showQuantity: ticket.showQuantity,
                转换后showQuantity: processedTicket.showQuantity,
                原showTime: ticket.showTime,
                转换后showTime: processedTicket.showTime
              });
              
              return processedTicket;
            });
            
            console.log('获取到门票列表:', this.ticketListData.length, '条记录');
          } else {
            console.error('门票列表数据格式异常:', response.data);
            this.ticketListData = [];
          }
          this.getSiteTicketStatus();
        } else {
          console.error('获取门票列表失败:', response.message);
          this.$message.error(response.message || '获取门票列表失败');
          this.ticketListData = [];
        }
      } catch (error) {
        console.error('获取门票列表异常:', error);
        this.$message.error('获取门票列表失败');
        this.ticketListData = [];
      }
    },
    
    // 获取门票状态
    async getSiteTicketStatus() {
      try {
        console.log('获取站点门票状态，站点ID:', this.currentSiteId);
        const response = await getSiteTicketStatus({ site_id: this.currentSiteId });
        console.log('站点门票状态响应:', response);
        
        if (response.status == '10000') {
          // 正确获取站点票功能开关状态
          if (response.data && typeof response.data.ticketEnabled !== 'undefined') {
            this.siteTicketEnabled = response.data.ticketEnabled;
            console.log('站点门票功能状态:', this.siteTicketEnabled);
          } else {
            console.warn('站点门票状态数据格式异常:', response.data);
            this.siteTicketEnabled = false;
          }
        } else {
          console.error('获取门票状态失败:', response.message);
          this.$message.error(response.message || '获取门票状态失败');
        }
      } catch (error) {
        console.error('获取门票状态异常:', error);
        this.$message.error('获取门票状态失败');
      }
    },
    
    // 门票状态变化
    async handleSiteTicketStatusChange(value) {
      try {
        console.log('更新站点门票状态:', value);
        const params = {
          site_id: this.currentSiteId,
          ticketEnabled: value
        };
        console.log('更新站点门票状态请求参数:', params);
        
        const response = await updateSiteTicketStatus(params);
        console.log('更新站点门票状态响应:', response);
        
        if (response.status !== "10000") {
          this.$message.error(response.message || '更新门票状态失败');
          this.siteTicketEnabled = !value; // 恢复UI状态
        } else {
          this.$message.success('更新门票状态成功');
        }
      } catch (error) {
        console.error('更新门票状态失败:', error);
        this.siteTicketEnabled = !value; // 恢复UI状态
        this.$message.error('更新门票状态失败');
      }
    },
    
    // 编辑门票
    async editTicket(ticket = null) {
      // 检查参数类型，确保正确处理来自表格和添加按钮的调用
      console.log('编辑门票函数接收参数:', ticket);
      
      if (ticket && typeof ticket === 'object' && (ticket.id || ticket._id)) {
        try {
          // 编辑现有门票 - 来自表格行
          this.dialogTitleTicketDetails = "编辑门票";
          
          // 查询最新的门票数据
          console.log('请求门票详情，ID:', ticket.id || ticket._id);
          const detailData = await this.getTicketDetail(ticket.id || ticket._id);
          console.log('获取到门票详情数据:', detailData);
          
          if (detailData) {
            // 使用详情API返回的数据
            this.formTicket = {
              id: detailData._id,
              ticketName: detailData.ticketName || '',
              ticketDescription: detailData.ticketDescription || '',
              startTime: detailData.startTime ? new Date(detailData.startTime) : '',
              endTime: detailData.endTime ? new Date(detailData.endTime) : '',
              ticketPrice: detailData.ticketPrice || '',
              ticketQuantity: detailData.ticketQuantity || '',
              // 明确处理布尔值，确保显示正确的开关状态
              status: detailData.status === true || detailData.status === 1,
              showQuantity: detailData.showQuantity === true || detailData.showQuantity === 1,
              showTime: detailData.showTime === true || detailData.showTime === 1,
            };
            
            // 输出转换后的布尔值，用于调试
            console.log('门票显示状态:', {
              原status: detailData.status, 
              转换后: this.formTicket.status,
              原showQuantity: detailData.showQuantity, 
              转换后: this.formTicket.showQuantity,
              原showTime: detailData.showTime, 
              转换后: this.formTicket.showTime
            });
            
            console.log('编辑门票模式 - 加载详细数据后的表单:', this.formTicket);
          } else {
            // 使用列表返回的数据作为备选
            this.formTicket = {
              id: ticket.id || ticket._id,
              ticketName: ticket.ticketName || '',
              ticketDescription: ticket.ticketDescription || '',
              startTime: ticket.startTime ? new Date(ticket.startTime) : '',
              endTime: ticket.endTime ? new Date(ticket.endTime) : '',
              ticketPrice: ticket.ticketPrice || '',
              ticketQuantity: ticket.ticketQuantity || '',
              // 确保正确转换布尔值
              status: ticket.status === true || ticket.status === 1,
              showQuantity: ticket.showQuantity === true || ticket.showQuantity === 1,
              showTime: ticket.showTime === true || ticket.showTime === 1,
            };
            
            // 输出转换后的布尔值，用于调试
            console.log('门票显示状态(使用列表数据):', {
              原status: ticket.status, 
              转换后: this.formTicket.status,
              原showQuantity: ticket.showQuantity, 
              转换后: this.formTicket.showQuantity,
              原showTime: ticket.showTime, 
              转换后: this.formTicket.showTime
            });
            
            console.log('编辑门票模式 - 使用传入数据的表单:', this.formTicket);
          }
          
          // 打开对话框
          this.dialogVisibleTicketDetails = true;
        } catch (error) {
          console.error('加载门票数据失败:', error);
          this.$message.error('加载门票数据失败');
        }
      } else {
        // 添加新门票
        this.dialogTitleTicketDetails = "添加门票";
        this.formTicket = {
          id: null, // 确保新门票没有ID
          ticketName: '',
          ticketDescription: '',
          startTime: '',
          endTime: '',
          ticketPrice: '',
          ticketQuantity: '',
          status: true,
          showQuantity: false,
          showTime: false,
        };
        console.log('添加门票模式 - 表单数据:', this.formTicket);
        this.dialogVisibleTicketDetails = true;
      }
    },
    
    // 新增：获取门票详情
    async getTicketDetail(ticketId) {
      try {
        console.log('获取门票详情，ID:', ticketId);
        
        // 使用ticketView函数而不是this.$http.get
        const response = await ticketView({ id: ticketId });
        
        console.log('门票详情响应:', response);
        
        if (response.status == '10000') {
          return response.data;
        }
        return null;
      } catch (error) {
        console.error('获取门票详情失败:', error);
        this.$message.error('获取门票详情失败');
        return null;
      }
    },
    
    // 保存门票
    saveTicket(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            // 如果票ID为null或undefined，则为添加操作
            const isAdd = !this.formTicket.id;
            console.log('保存门票操作类型:', isAdd ? '添加' : '编辑', this.formTicket);
            
            // 确保日期格式正确
            let startTime = this.formTicket.startTime;
            let endTime = this.formTicket.endTime;
            
            // 如果是Date对象，转换为ISO字符串
            if (startTime instanceof Date) {
              startTime = startTime.toISOString();
            }
            
            if (endTime instanceof Date) {
              endTime = endTime.toISOString();
            }
            
            // 确保布尔值被正确转换
            const statusValue = this.formTicket.status ? 1 : 0;
            const showQuantityValue = this.formTicket.showQuantity ? 1 : 0;
            const showTimeValue = this.formTicket.showTime ? 1 : 0;
            
            console.log('转换后的开关状态:', {
              status: this.formTicket.status + ' → ' + statusValue,
              showQuantity: this.formTicket.showQuantity + ' → ' + showQuantityValue,
              showTime: this.formTicket.showTime + ' → ' + showTimeValue
            });
            
            const params = {
              siteId: this.currentSiteId,
              ticketName: this.formTicket.ticketName,
              ticketDescription: this.formTicket.ticketDescription || '',
              startTime: startTime || '',
              endTime: endTime || '',
              ticketPrice: this.formTicket.ticketPrice || 0,
              ticketQuantity: this.formTicket.ticketQuantity || 0,
              status: statusValue, // 使用转换后的值
              showQuantity: showQuantityValue, // 使用转换后的值
              showTime: showTimeValue, // 使用转换后的值
            };
            
            // 编辑模式下需要传入id
            if (!isAdd) {
              params.id = this.formTicket.id;
            }
            
            console.log('保存门票请求参数:', params);
            const response = await ticketSave(isAdd, params);
            console.log('保存门票响应:', response);
            
            if (response.status == '10000') {
              this.$message.success("保存成功");
              this.dialogVisibleTicketDetails = false;
              this.getTicketList();
            } else {
              this.$message.error(response.message || "保存失败");
            }
          } catch (error) {
            console.error('保存门票失败:', error);
            this.$message.error("保存失败");
          }
        } else {
          console.warn('表单验证失败');
          this.$message.warning("请完善表单信息");
        }
      });
    },
    
    // 门票启用状态变化
    async handleStatusChange(row) {
      try {
        console.log('门票行数据:', row);
        
        // 如果没有ID字段，无法更新
        if (!row || (!row.id && !row._id)) {
          this.$message.error('无效的门票数据');
          return;
        }
        
        // 保存原始状态，以便回滚
        const originalStatus = row.status;
        
        try {
          // 这是修改操作，需要带上完整的参数
          const isAdd = false;
          
          // 确保日期格式正确
          let startTime = row.startTime;
          let endTime = row.endTime;
          
          // 如果是Date对象，转换为ISO字符串
          if (startTime instanceof Date) {
            startTime = startTime.toISOString();
          }
          
          if (endTime instanceof Date) {
            endTime = endTime.toISOString();
          }
          
          const params = {
            id: row.id || row._id, // 确保使用正确的ID字段
            site_id: this.currentSiteId,
            status: row.status ? 1 : 0,
            // 保留其他必要字段，避免API报错
            ticketName: row.ticketName || '默认门票',
            ticketPrice: parseFloat(row.ticketPrice) || 0,
            ticketQuantity: parseInt(row.ticketQuantity) || 0,
            // 如果有时间字段，也应该传入
            startTime: startTime || '',
            endTime: endTime || '',
            ticketDescription: row.ticketDescription || '',
            showQuantity: row.showQuantity ? 1 : 0,
            showTime: row.showTime ? 1 : 0,
          };
          
          console.log('修改门票状态请求参数:', params);
          const response = await ticketSave(isAdd, params);
          console.log('修改门票状态响应:', response);
          
          if (response.status !== "10000") {
            this.$message.error(response.message || '更新状态失败');
            row.status = !row.status; // 恢复UI状态
          } else {
            this.$message.success('状态更新成功');
            // 更新列表
            this.getTicketList();
          }
        } catch (error) {
          console.error('更新状态失败:', error);
          row.status = originalStatus; // 恢复原始状态
          this.$message.error('更新状态失败');
        }
      } catch (e) {
        console.error('门票状态切换异常:', e);
        this.$message.error('操作异常');
      }
    },
    
    // 删除门票
    deleteTicket(ticket) {
      console.log('删除门票函数接收参数:', ticket);
      
      if (!ticket || (!ticket.id && !ticket._id)) {
        this.$message.error('无效的门票数据');
        return;
      }
      
      // 确保有正确的ID
      const ticketId = ticket.id || ticket._id;
      
      this.$confirm("此操作将永久删除该门票，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        try {
          const params = {
            id: ticketId,
            site_id: this.currentSiteId
          };
          console.log('删除门票请求参数:', params);
          
          const response = await ticketDelete(params);
          console.log('删除门票响应:', response);
          
          if (response.status == '10000') {
            this.$message.success("删除成功");
            // 更新列表
            this.getTicketList();
          } else {
            this.$message.error(response.message || "删除失败");
          }
        } catch (error) {
          console.error('删除门票失败:', error);
          this.$message.error("删除失败，请稍后重试");
        }
      }).catch(() => {
        console.info("已取消删除");
      });
    },
    
    // 获取最新的项目数据
    async getLatestProjectData() {
      try {
        const { status, data } = await getProjectById({ id: "66efd204cb155e2a185209f5" });
        if (status == 10000 && data) {
          // 更新Vuex 或 localStorage
          this.setProject(data);
          this.$message.success("已获取最新项目数据");
          return true;
        } else {
          console.error('获取项目数据失败:', status);
          this.$message.warning("获取最新数据失败，将使用本地缓存的数据");
          return false;
        }
      } catch (error) {
        console.error('获取项目数据异常:', error);
        this.$message.warning("获取最新数据失败，将使用本地缓存的数据");
        return false;
      }
    },
    
    // 获取站点页面列表
    getSitePages(siteId) {
      // 直接从项目数据中获取页面列表
      this.currentSiteId = siteId;
      this.sitePages = this.project.pages.filter(page => page.site === siteId);
      
      // 如果没有找到页面数据，显示提示
      if (this.sitePages.length === 0) {
        console.log('当前站点没有页面数据:', siteId);
      }
    },
    
    // 添加页面
    async addPage() {
      try {
        // 创建新页面对象 - 不包含默认组
        const newPage = {
          id: this.generateUniqueId(),
          name: "新页面",
          site: this.currentSiteId,
          site_home: this.sitePages.length === 0, // 如果是第一个页面，自动设为首页
          viewCount: 0,
          updatedAt: new Date(),
          componentList: [], // 空的组件列表
          schema: {
            type: 'template',
            components: []
          }
        };
        
        // 添加到项目数据中
        this.project.pages.push(newPage);
        
        // 更新本地页面列表
        this.sitePages.push(newPage);
        
        // 保存项目以更新后端数据
        const success = await this.saveProject();
        if (success) {
          this.$message.success("添加页面成功");
        } else {
          this.$message.warning("页面已添加，但同步到服务器失败，请稍后重试");
        }
      } catch (error) {
        console.error('添加页面失败:', error);
        this.$message.error("添加页面失败，请重试");
      }
    },
    
    // 编辑页面标题
    editPageTitle(page) {
      this.currentPage = { ...page };
      this.dialogVisiblePageTitle = true;
    },
    
    // 保存页面标题
    async savePageTitle(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            // 如果设置为首页，需要将其他页面的首页标志取消
            if (this.currentPage.site_home) {
              // 更新项目中的其他页面
              this.project.pages.forEach(page => {
                if (page.site === this.currentSiteId && page.id !== this.currentPage.id) {
                  page.site_home = false;
                }
              });
              
              // 同步更新本地列表
              this.sitePages.forEach(page => {
                if (page.id !== this.currentPage.id) {
                  page.site_home = false;
                }
              });
            }
            
            // 更新项目中的页面信息
            const pageIndex = this.project.pages.findIndex(page => page.id === this.currentPage.id);
            if (pageIndex !== -1) {
              this.project.pages[pageIndex] = {
                ...this.project.pages[pageIndex],
                name: this.currentPage.name,
                site_home: this.currentPage.site_home,
                updatedAt: new Date()
              };
              
              // 更新本地列表
              const localIndex = this.sitePages.findIndex(page => page.id === this.currentPage.id);
              if (localIndex !== -1) {
                this.sitePages[localIndex] = {
                  ...this.sitePages[localIndex],
                  name: this.currentPage.name,
                  site_home: this.currentPage.site_home,
                  updatedAt: new Date()
                };
              }
              
              // 保存项目
              const success = await this.saveProject();
              if (success) {
                this.$message.success("保存成功");
                this.dialogVisiblePageTitle = false;
              } else {
                this.$message.warning("本地已更新，但同步到服务器失败，请稍后重试");
              }
            }
          } catch (error) {
            console.error('保存页面标题失败:', error);
            this.$message.error("保存失败，请重试");
          }
        }
      });
    },
    
    // 编辑页面内容
    editPageContent(page) {
      // 设置当前页面并导航到编辑界面
      this.setCurPage(page);
      this.$router.push({ name: "page-build" });
    },
    
    // 删除页面
    deletePage(page) {
      // 首页不允许删除
      if (page.site_home) {
        this.$message.warning("首页不能删除");
        return;
      }
      
      this.$confirm("删除页面后不可恢复，确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        try {
          // 从项目中移除页面
          this.project.pages = this.project.pages.filter(p => p.id !== page.id);
          
          // 更新本地列表
          this.sitePages = this.sitePages.filter(p => p.id !== page.id);
          
          // 保存项目
          const success = await this.saveProject();
          if (success) {
            this.$message.success("删除成功");
          } else {
            this.$message.warning("本地已删除，但同步到服务器失败，请稍后重试");
          }
        } catch (error) {
          console.error('删除页面失败:', error);
          this.$message.error("删除失败，请重试");
        }
      }).catch(() => {
        console.info("已取消删除");
      });
    },
    
    // 打开门票管理
    openTicketManagement(site) {
      // 设置当前站点ID
      this.currentSiteId = site._id;
      
      // 设置标题
      this.dialogTitleTicket = "门票管理 - " + site.name;
      
      // 重置门票列表数据
      this.ticketListData = [];
      
      // 打开对话框
      this.dialogVisibleTicket = true;
      
      // 获取数据
      this.getTicketList();
    },
    
    // 设置基础设置
    openSettings(site) {
      this.currentSiteId = site._id;
      this.dialogTitleShare = "基础设置";
      this.dialogVisibleShare = true;
      this.getFormOptions();
      this.getShareSettings();
    },
    
    // 保存分享设置
    async saveShare() {
      try {
        const { status, message } = await setShareSetting({
          site_id: this.currentSiteId,
          title: this.shareData.title,
          icon: this.shareData.icon,
          description: this.shareData.description,
          formId: this.shareData.formId || '',
          site_switch: this.shareData.site_switch
        });
        
        if (status == '10000') {
          this.$message.success("保存成功");
          this.dialogVisibleShare = false;
        } else if (status == '10002') {
          // 表单已被绑定
          this.$message.error(message || "该表单已被其他站点绑定，请选择其他表单");
          // 将表单ID重置为空
          this.shareData.formId = '';
        } else {
          this.$message.error(message || "保存失败");
        }
      } catch (error) {
        console.error('保存设置失败:', error);
        this.$message.error('保存失败，请重试');
      }
    },
    
    // 获取分享设置
    async getShareSettings() {
      try {
        const { status, message, data } = await getShareSetting({
          site_id: this.currentSiteId,
        });
        
        if (status == '10000') {
          this.shareData = {
            title: data?.title || '',
            icon: data?.icon || '',
            description: data?.description || '',
            formId: data?.formId || '',
            site_switch: data?.site_switch || '1'
          };
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        console.error('获取分享设置失败:', error);
        this.$message.error('获取分享设置失败');
      }
    },
    
    // 查看门票用户列表
    viewTicketUsers(ticket) {
      this.currentTicket = ticket;
      this.ticketUsersPage = 1;
      this.ticketUserPaymentFilter = null;
      this.showTicketUserDialog = true;
      this.getTicketUsers(ticket);
    },
    
    // 获取门票用户列表
    async getTicketUsers(ticket) {
      try {
        this.ticketUsersLoading = true;
        const params = {
          ticketId: ticket._id,
          page: this.ticketUsersPage,
          limit: this.ticketUsersPageSize
        };
        
        // 如果有筛选支付状态，添加到查询参数
        if (this.ticketUserPaymentFilter) {
          params.paymentStatus = this.ticketUserPaymentFilter;
        }
        
        const response = await getTicketUsers(params);
        console.log('门票用户列表响应:', response);
        
        if (response.status == '10000') {
          if (response.data) {
            this.ticketUserList = response.data.users || [];
            this.ticketUsersTotal = response.data.total || 0;
            console.log('获取到门票用户列表:', this.ticketUserList.length, '条记录');
          } else {
            console.error('门票用户列表数据格式异常:', response.data);
            this.ticketUserList = [];
            this.ticketUsersTotal = 0;
          }
        } else {
          console.error('获取门票用户列表失败:', response.message);
          this.ticketUserList = [];
          this.ticketUsersTotal = 0;
        }
      } catch (error) {
        console.error('获取门票用户列表异常:', error);
        this.ticketUserList = [];
        this.ticketUsersTotal = 0;
        this.$message.error('获取门票用户列表失败');
      } finally {
        this.ticketUsersLoading = false;
      }
    },
    
    // 处理用户分页
    handleUserPageChange(page) {
      this.ticketUsersPage = page;
      this.getTicketUsers(this.currentTicket);
    },
    
    // 处理支付状态筛选
    handlePaymentFilterChange(value) {
      this.ticketUserPaymentFilter = value;
      this.getTicketUsers(this.currentTicket);
    },
    
    // 导出用户
    exportTicketUsers() {
      // 这里需要实现导出用户的功能
      console.log('导出用户:', this.ticketUserList);
    },
    
    // 查看用户表单数据
    viewUserFormData(user) {
      // 这里需要实现查看用户表单数据的功能
      console.log('查看用户表单数据:', user);
      this.currentFormData = user;
      this.showFormDataDialog = true;
    },
    
    // 获取支付状态标签类型
    getPaymentStatusType(status) {
      switch (status) {
        case 'paid':
          return 'success';
        case 'unpaid':
          return 'info';
        case 'failed':
          return 'danger';
        case 'refunded':
          return 'warning';
        default:
          return 'info';
      }
    },
    
    // 获取支付状态文本
    getPaymentStatusText(status) {
      switch (status) {
        case 'paid':
          return '已支付';
        case 'unpaid':
          return '未支付';
        case 'failed':
          return '支付失败';
        case 'refunded':
          return '已退款';
        default:
          return '未知状态';
      }
    },
    
    // 处理表单数据对话框关闭
    handleFormDataDialogClose() {
      this.showFormDataDialog = false;
      this.currentFormData = null;
    },
    
    // 处理门票用户对话框关闭
    handleTicketUserDialogClose() {
      this.showTicketUserDialog = false;
      this.ticketUserPaymentFilter = null;
      this.ticketUserList = [];
    },
    
    // 处理门票用户分页大小变化
    handleTicketUsersSizeChange(size) {
      this.ticketUsersPageSize = size;
      this.getTicketUsers(this.currentTicket);
    },
    
    // 处理门票用户当前页变化
    handleTicketUsersCurrentChange(page) {
      this.ticketUsersPage = page;
      this.getTicketUsers(this.currentTicket);
    },
  },
  watch: {
    // 当门票用户列表对话框关闭时重置currentTicket
    dialogVisibleTicketUsers(val) {
      if (!val) {
        // 对话框关闭时重置状态
        this.currentTicket = null;
        this.ticketUserList = [];
        this.ticketUsersTotal = 0;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: calc(100vh - 60px);
  background: #f5f7fa;

  .containter {
    width: 100%;
    height: 100%;
    display: flex;
    padding: 16px;
    gap: 16px;

    .content {
      flex: 1 1 auto;
      min-width: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      background: white;
      border-radius: 12px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
      overflow: hidden;
    }

    .c-header {
      display: flex;
      height: 64px;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;
      border-bottom: 1px solid #f0f0f0;
      background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
    }

    .header-group-left {
      .el-button {
        min-width: 100px;
        height: 36px;
        border-radius: 6px;
        font-weight: 500;
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
        
        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
        }
      }
    }

    .c-main {
      flex: 1 1 auto;
      min-height: auto;
      overflow: auto;
      padding: 24px;
    }
  }
}

.microsite-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 24px;
  padding: 0;
}

.microsite-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  border: 1px solid #f0f0f0;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    border-color: #e0e0e0;

    .microsite-hover-actions {
      opacity: 1;
      backdrop-filter: blur(4px);
    }
  }
}

.microsite-cover {
  height: 200px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.05) 100%);
    transition: all 0.3s ease;
  }
  
  // 添加封面加载失败时的默认样式
  &.cover-error {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    
    &::before {
      background: rgba(0, 0, 0, 0.3);
    }
    
    .cover-error-text {
      color: white;
      font-size: 16px;
      font-weight: 500;
      z-index: 1;
    }
  }
}

.microsite-hover-actions {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.qrcode-container {
  text-align: center;
  margin-bottom: 20px;
  
  canvas {
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
}

.qrcode-title {
  color: white;
  font-size: 13px;
  margin-top: 10px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.hover-actions-buttons {
  display: flex;
  gap: 12px;
  
  .el-button {
    border-radius: 6px;
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }
  }
}

.microsite-info {
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 200px); /* 减去封面高度 */
  min-height: 140px; /* 确保最小高度 */
}

.microsite-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  flex-shrink: 0;
}

.microsite-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  flex: 1;
  line-height: 1.4;
  letter-spacing: -0.2px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 2.8em;
  word-break: break-word;
  min-height: 1.4em; /* 确保单行标题也有足够高度 */
}

.microsite-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 12px;
  color: #6b7280;
  font-size: 14px;
  flex-shrink: 0;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 6px;
  
  i {
    font-size: 16px;
    color: #9ca3af;
  }
}

.microsite-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto; /* 将按钮推到卡片底部 */
  flex-shrink: 0;
  
  .el-button {
    border-radius: 6px;
    font-weight: 500;
    
    &:hover {
      transform: translateY(-1px);
    }
  }
  
  .el-dropdown {
    .el-button {
      border-radius: 6px;
      padding: 7px 12px;
      
      i {
        font-size: 16px;
      }
    }
  }
}

.cover-container {
  .cover-uploader {
    .image-wrapper {
      width: 120px;
      height: 120px;
      border: 2px dashed #d9d9d9;
      border-radius: 8px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        border-color: #409EFF;
        transform: scale(1.02);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
        
        .cover-actions {
          opacity: 1;
          transform: translateY(0);
        }
      }
    }

    .cover-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }

    .cover-uploader-icon {
      font-size: 32px;
      color: #8c939d;
      transition: color 0.3s ease;
    }
    
    .cover-actions {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.7);
      display: flex;
      justify-content: center;
      padding: 8px;
      opacity: 0;
      transform: translateY(10px);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
    
    .cover-action-btn {
      color: white !important;
      padding: 4px 8px;
      margin: 0 4px;
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.2);
      border: none;
      
      &:hover {
        background: rgba(255, 255, 255, 0.3);
        transform: scale(1.1);
      }
      
      i {
        font-size: 14px;
      }
    }
  }
  
  .cover-tips {
    margin-top: 8px;
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
    
    i {
      margin-right: 4px;
      color: #409EFF;
    }
  }
}

// 封面预览对话框样式
.cover-preview-dialog {
  .el-message-box {
    width: auto;
    max-width: 600px;
    
    .el-message-box__header {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      
      .el-message-box__title {
        color: white;
      }
      
      .el-message-box__headerbtn {
        .el-message-box__close {
          color: white;
          
          &:hover {
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }
    }
    
    .el-message-box__content {
      padding: 20px;
    }
  }
}

// 添加表单样式
.article-form {
  display: flex;
  gap: 20px;
}

.article-form-left {
  flex: 1;
}

.ticket-form {
  display: flex;
  gap: 20px;
}

.ticket-form-left,
.ticket-form-right {
  flex: 1;
}

.form-item-hint {
  margin-left: 10px;
  font-size: 12px;
  color: #909399;
}

.user-info-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-details {
  flex: 1;
}

.form-data-item {
  display: flex;
  margin-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 8px;
}

.form-data-label {
  font-weight: bold;
  color: #333;
  min-width: 120px;
  flex-shrink: 0;
}

.form-data-value {
  color: #666;
  flex: 1;
  word-break: break-all;
}

.empty-form-data {
  text-align: center;
  color: #999;
  padding: 20px;
}

.form-iframe {
  width: 100%;
  height: calc(100vh - 120px); /* 减去对话框头部和一些边距 */
  border: none;
}

// 响应式布局
@media (max-width: 1200px) {
  .microsite-grid {
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .wrap {
    .containter {
      padding: 12px;
      gap: 12px;
      
      .content {
        border-radius: 8px;
      }
      
      .c-header {
        height: 56px;
        padding: 0 16px;
      }
      
      .c-main {
        padding: 16px;
      }
    }
  }
  
  .microsite-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .microsite-card {
    border-radius: 8px;
  }
  
  .microsite-cover {
    height: 160px;
  }
  
  .microsite-info {
    padding: 16px;
  }
  
  .microsite-title {
    font-size: 16px;
  }
  
  .hover-actions-buttons {
    flex-direction: column;
    gap: 8px;
    
    .el-button {
      width: 120px;
    }
  }
}

// 调整对话框样式
::v-deep .el-dialog {
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
  
  .el-dialog__header {
    padding: 24px 24px 0;
    border-bottom: 1px solid #f0f0f0;
    
    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: #1f2937;
    }
  }
  
  .el-dialog__body {
    padding: 24px;
  }
  
  .el-dialog__footer {
    padding: 0 24px 24px;
    border-top: 1px solid #f0f0f0;
  }
  
  .el-form-item__label {
    font-weight: 500;
    color: #374151;
  }
  
  .el-select {
    width: 100%;
  }
  
  .el-input__inner {
    border-radius: 6px;
    border: 1px solid #d1d5db;
    
    &:focus {
      border-color: #3b82f6;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
  }
}

// 模板选择对话框样式
.template-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  padding: 24px 0;
}

.template-item {
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  background: white;
}

.template-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(64, 158, 255, 0.15);
  border-color: #e0e0e0;
}

.template-preview {
  position: relative;
  width: 100%;
  aspect-ratio: 9/16;
  overflow: hidden;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border-radius: 12px 12px 0 0;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.template-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
  transition: transform 0.3s ease;
  border: 1px solid #e5e7eb;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.template-item:hover .template-image {
  transform: scale(1.02);
}

.template-title {
  padding: 20px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  background-color: #ffffff;
  border-top: 1px solid #f8fafc;
}

// 空状态样式
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  text-align: center;
  color: #6b7280;
  
  .empty-icon {
    font-size: 64px;
    margin-bottom: 24px;
    color: #d1d5db;
  }
  
  .empty-text {
    font-size: 18px;
    margin-bottom: 12px;
    font-weight: 500;
  }
  
  .empty-description {
    font-size: 14px;
    margin-bottom: 24px;
    max-width: 400px;
    line-height: 1.5;
  }
}

// 加载状态优化
::v-deep .el-loading-mask {
  border-radius: 12px;
  
  .el-loading-spinner {
    .circular {
      width: 32px;
      height: 32px;
    }
    
    .el-loading-text {
      font-size: 14px;
      margin-top: 12px;
    }
  }
}
</style>
